module.exports = __webpack_public_path__ + "img/2-1.db473d7a.jpg";